import { Flex, Spacing } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { FC, memo } from 'react';
import bemFactory from 'react-bem-factory';

import FieldEntry from '../../../components/FieldEntry';
import { SectionContainer } from '../../../components/SectionContainer/SectionContainer';
import { messages } from './QBooksMemoFields.messages';
import { QBooksMemoFieldsProps } from './QBooksMemoFields.types';

const qa = bemFactory.qa('reql-qbooks-request-card');

export const QBooksMemoFields: FC<QBooksMemoFieldsProps> = memo((props) => {
    const { details } = props;

    const memo = 'memo' in details && details.memo;

    let message = 'vendorMessage' in details && details.vendorMessage;
    let messageFieldTitle = messages.vendorMessageFieldTitle;
    let memoFieldTitle = messages.memoFieldTitle;
    let sectionTitle;

    if (details.integrationCode === domain.IntegrationCode.QBooksInvoice) {
        message = details.customerMemo;
        messageFieldTitle = messages.messageOnInvoiceFieldTitle;
        memoFieldTitle = messages.messageOnStatementFieldTitle;
        sectionTitle = messages.sectionTitle;
    }

    if (!(message || memo)) {
        return null;
    }

    return (
        <SectionContainer title={(memo || message) && sectionTitle}>
            <Flex container wrap={false}>
                {message && (
                    <Flex grow={1} minWidth='50%'>
                        <FieldEntry qa={qa('vendorMessage-field')} title={messageFieldTitle} value={message} />
                    </Flex>
                )}

                {memo && (
                    <Flex grow={1} minWidth='50%'>
                        <FieldEntry qa={qa('memo-field')} title={memoFieldTitle} value={details.memo} />
                    </Flex>
                )}
            </Flex>

            <Spacing height={20} />
        </SectionContainer>
    );
});

QBooksMemoFields.displayName = 'QBooksMemoFields';
